export const SMART_ERASE_URL = '/v1/products/image/smart-erase';
export const CHANGE_IMAGE_BACKGROUND_URL =
  '/v1/products/image/change-background';
export const SUGGESTED_GOOGLE_CATEGORIES_URL =
  '/v1/categories/suggested-google-categories';
export const GET_USAGE_URL = '/v1/ai/usage';
export const GET_USAGE_REPORT_URL = '/v1/ai/usage/report';
export const GET_USAGE_LIMITS_URL = '/v1/ai/usage/limits';
